module.exports = __webpack_public_path__ + "img/w_television.1119cb3b.svg";